module.exports = __webpack_public_path__ + "img/compitem.6f17ab7c.png";